import moment from "moment/moment";

export const nullSafeComparator = (a, b, compare) => {
    if (a === null || b === null) {
        return (a === null) - (b === null);
    }
    if (a === undefined || b === undefined) {
        return (a === undefined) - (b === undefined);
    }
    return compare(a, b);
};

export const numbersComparator = (a, b) => {
    return nullSafeComparator(a, b, (a, b) => a - b);
};

export const stringsComparator = (a, b) => {
    return nullSafeComparator(a, b, (a, b) => a.localeCompare(b));
};

export const getDatesComparator = (a, b, direction) => {
    return direction === "asc"
        ? (a, b) => (moment(a).isAfter(moment(b)) ? 1 : -1)
        : (a, b) => (moment(a).isBefore(b) ? 1 : -1);
};

export const compareBy = (a, b, gettersAndComparators) => {
    for (let i = 0; i < gettersAndComparators.length; i++) {
        const { getter, comparator } = gettersAndComparators[i];
        const aValue = getter(a);
        const bValue = getter(b);
        const result = comparator(aValue, bValue);
        if (result !== 0) {
            return result;
        }
    }

    return -1;
};
